module.exports = __webpack_public_path__ + "img/train-5.b181439d.jpg";